let audioContext = null;
let masterGainNode = null;

const MASTER_VOLUME = 0.72;

const getAudioContext = () => {
    const AudioContextClass = window.AudioContext || window.webkitAudioContext;
    if (!AudioContextClass) return null;

    if (!audioContext) {
        audioContext = new AudioContextClass();
    }

    if (audioContext.state === "suspended") {
        audioContext.resume().catch(() => {});
    }

    if (!masterGainNode) {
        masterGainNode = audioContext.createGain();
        masterGainNode.gain.value = MASTER_VOLUME;
        masterGainNode.connect(audioContext.destination);
    }

    return audioContext;
};

const playTone = (frequency, startTime, duration, gainValue, type = "triangle") => {
    const context = getAudioContext();
    if (!context) return;

    const oscillator = context.createOscillator();
    const gain = context.createGain();
    const filter = context.createBiquadFilter();

    oscillator.type = type;
    oscillator.frequency.setValueAtTime(frequency, startTime);
    filter.type = "lowpass";
    filter.frequency.setValueAtTime(2600, startTime);
    gain.gain.setValueAtTime(0.0001, startTime);
    gain.gain.exponentialRampToValueAtTime(gainValue, startTime + 0.008);
    gain.gain.exponentialRampToValueAtTime(0.0001, startTime + duration);

    oscillator.connect(filter);
    filter.connect(gain);
    gain.connect(masterGainNode || context.destination);
    oscillator.start(startTime);
    oscillator.stop(startTime + duration + 0.02);
};

export const playScanSuccessSound = () => {
    const context = getAudioContext();
    if (!context) return;

    const now = context.currentTime;
    playTone(1046, now, 0.1, 0.22, "triangle");
    playTone(1568, now + 0.085, 0.14, 0.2, "triangle");
};

export const playScanErrorSound = () => {
    const context = getAudioContext();
    if (!context) return;

    const now = context.currentTime;
    playTone(392, now, 0.11, 0.24, "sawtooth");
    playTone(196, now + 0.105, 0.2, 0.22, "sawtooth");
};
